import React from "react";
import { View, Image, useWindowDimensions, Platform } from "react-native";
import { LOGO } from "../../resources/IMAGES";
import LoginButton from "./LoginButton";
import SmartLinksComponent from "./SmartLinksComponent";
import LoginFooter from "./LoginFooter";
import { styles } from "./styles/LoginView.styles";
import { isQRVisible, QR_WIDTH_CONSTANTS } from "@lib/utilities/Constants";
import { theme } from "../../theme/theme";
import { isTablet } from "react-native-device-info";

const LoginView = ({ onLoginPress }: any) => {
  const { width, height } = useWindowDimensions();
  // Dynamic scaling
  const isTabletDevice = width > QR_WIDTH_CONSTANTS.tablets;
  const isDesktop = width > QR_WIDTH_CONSTANTS.largeDesktop;
  const isMobile = width > QR_WIDTH_CONSTANTS.smallDevice;

  const logoWidth = isDesktop ? 500 : isTabletDevice ? 450 : width * 0.7;
  const marginBottom = isDesktop ? 40 : isTabletDevice ? 30 : 20;
  const logoHeight = logoWidth * 0.4;

  return (
    <View
      style={[
        styles.container,
        Platform.select({
          web: {
            minHeight: height,
          },
        }),
      ]}
    >
      <View
        style={[
          styles.logoContainer,
          Platform.select({
            web: {
              top: isMobile ? -height * 0.08 : 0,
            },
            ios: {
              // bottom: isTablet() ? -height * 0.02 : 0,
            },
          }),
        ]}
        testID="login-page-content-container"
      >
          <Image
            source={LOGO}
            style={
              Platform.OS === "web"
                ? {
                    width: logoWidth,
                    height: logoHeight,
                    resizeMode: "contain",
                    marginVertical: marginBottom,
                    marginTop:
                      width < QR_WIDTH_CONSTANTS.smallDevice ? -height * 0.1 : 0,
                  }
                : [styles.logo]
            }
            testID="login-page-brand-image"
          />
        <LoginButton onLoginPress={onLoginPress} />
      </View>

      <View
        style={[
          styles.contentContainer,
          Platform.OS == "web" && {
            bottom: width < QR_WIDTH_CONSTANTS.isMobile ? -theme.margin.reg : 0,
            transform: [
              { scale: width < QR_WIDTH_CONSTANTS.isMobile ? 0.85 : 1 },
            ],
          },
        ]}
      >
        {isQRVisible() && <SmartLinksComponent />}
        <LoginFooter />
      </View>
    </View>
  );
};

export default LoginView;
